import {
  Taxonomy,
  TaxonomyFieldsMap,
  TaxonomyMapping,
  TaxonomyShortMap,
  TaxonomyType,
} from './taxonomy.types';
import apiV2Service from '../api/api-v2.service';
import {toClientTaxonomyFieldsMap} from './taxonomy.dataConverters';
import {analytics, taxonomy} from '@cl/shared';
import analyticsApi from '../analytics/analytics.api';

const {cachedAnalyticsSubject} = analytics;
const {taxonomyPromise, taxonomyFieldsPromise} = taxonomy;

const BASE_PATH = 'Taxonomy';

function getFields(skipCache = false): Promise<TaxonomyFieldsMap> {
  if (skipCache) {
    taxonomyFieldsPromise.current = null;
  }

  return (taxonomyFieldsPromise.current =
    taxonomyFieldsPromise.current ??
    apiV2Service
      .executeGetRequest<{options: TaxonomyFieldsMap}>(`${BASE_PATH}/fields`)
      .then((res) => toClientTaxonomyFieldsMap(res.data.options))
      .catch((error) => {
        taxonomyFieldsPromise.current = null;
        throw error;
      }));
}

async function get(type: TaxonomyType): Promise<Taxonomy[]> {
  return apiV2Service.executeGetRequest<Taxonomy[]>(BASE_PATH, {type}).then(({data}) => data);
}

function getMapping(skipCache = false) {
  if (skipCache) {
    taxonomyPromise.current = null;
  }

  taxonomyPromise.current =
    taxonomyPromise.current ??
    apiV2Service
      .executeGetRequest<{mapping: TaxonomyMapping}>(`${BASE_PATH}/mapping`)
      .then(({data}) => data.mapping)
      .catch((error) => {
        taxonomyPromise.current = null;
        throw error;
      });

  return taxonomyPromise.current;
}

function update(fields: TaxonomyShortMap[], type: TaxonomyType) {
  return apiV2Service.executePostRequest(`${BASE_PATH}/Update`, {}, {type, fields}).finally(() => {
    analyticsApi.getUiNames().then(
      ({metrics, dimensions, customConversions}) =>
        (cachedAnalyticsSubject.data.uiNameMapping = {
          ...cachedAnalyticsSubject.data.uiNameMapping,
          ...(metrics ?? {}),
          ...(dimensions ?? {}),
          ...(customConversions ?? {}),
        }),
    );
  });
}

async function getUsedKeysInMyReports() {
  const {data} = await apiV2Service.executeGetRequest<Record<TaxonomyType, string[]>>(
    `${BASE_PATH}/UsedKeysInMyReports`,
  );

  return data;
}

const taxonomyApi = {
  get,
  update,
  getFields,
  getMapping,
  getUsedKeysInMyReports,
};

export default taxonomyApi;
